<template>
  <div class="cateInfo" @click="goToCategory">
    <div class="thumb">
      <img :src="cateInfo.thumbnail" :alt="getCateName" />
    </div>
    <div class="content">
      <img :src="cateInfo.embed_icon" :alt="getCateName" />
      <span v-text="getCateName"></span>
    </div>
  </div>
</template>
<script>
import { get } from "lodash";
export default {
  props: ["cateInfo"],
  methods: {
    get,
    goToCategory() {
      this.$router.push({
        name: "Category",
        params: {
          slug: this.cateInfo.slug,
          locale: this.locale,
        },
      });
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    getCateName() {
      return get(this.cateInfo, `${this.locale}.name`);
    },
  },
};
</script>
<style lang="scss">
.cateInfo {
  margin-bottom: 20px;
  cursor: pointer;
  &:hover,
  &:focus {
    .content {
      background: #c63543;

      span {
        color: #fff;
      }
      img {
        filter: brightness(0) invert(1);
      }
    }
  }
  .thumb {
    position: relative;
    img {
      opacity: 1;
      transition: opacity 0.25s ease-in-out;
    }
    &::after {
      content: "»";
      position: absolute;
      opacity: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      transition: opacity 0.25s ease-in-out;
      font-size: 60px;
      color: #c63543;
    }
    &:hover {
      img {
        opacity: 0.3;
      }
      &::after {
        opacity: 1;
      }
    }

    img {
      display: block;
      width: 100%;
    }
  }
  .content {
    text-align: center;
    padding: 10px;
    background: #fff;
    transition: all 0.3s;
    span {
      text-transform: uppercase;
      font-weight: 700;
      margin-left: 10px;
    }
    img {
      width: 46px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  @media (max-width: 768px) {
    .content {
      padding: 5px;
      img {
        width: 24px;
      }
      span {
        font-size: 14px;
      }
    }
  }
}
</style>
